import { useFigureRendererFromUrl } from "../figures";

export default () => {
  const Renderer = useFigureRendererFromUrl({ renderMode: "embed" });
  return Renderer;
};
